import * as React from "react"
import {Button, Carousel as BootstrapCarousel, Col, Container, Image, Modal, Row} from "react-bootstrap";
import {FaCheck, FaChevronCircleLeft, FaChevronCircleRight} from "react-icons/fa";
import {useReviewMediaQuery} from "../../../hooks/useReviewMediaQuery";
import {StarRating} from "../../../components/starRating";
import Carousel from "react-multi-carousel";

const mediaCarouselResponsive = {
    largeDesktop: {
        breakpoint: {max: 4000, min: 1200},
        items: 5,
        partialVisibilityGutter: 10
    },
    desktop: {
        breakpoint: {max: 1200, min: 768},
        items: 4,
        partialVisibilityGutter: 10
    },
    largeMobile: {
        breakpoint: {max: 768, min: 576},
        items: 3,
        partialVisibilityGutter: 10
    },
    mobile: {
        breakpoint: {max: 576, min: 440},
        items: 2,
        partialVisibilityGutter: 10
    },
    extraSmallMobile: {
        breakpoint: {max: 440, min: 0},
        items: 2,
        partialVisibilityGutter: 0
    }
};

export const Media = () => {
    const {
        model: {visibleMedia, mediaPreview},
        activeMedium: {
            activeIndex,
            setActiveIndex,
            medium: activeMedium,
            media,
            hasMedia,
        },
        modal: {header},
        error
    } = useReviewMediaQuery();

    // If there is an error or no media, don't render anything
    if (error || mediaPreview.length === 0) return <></>;

    return (
        <Col xs={12} className="mt-3 p-3 bg-light">
            <h5 className="fw-normal">Customer Photos</h5>
            <Carousel
                swipeable={true}
                draggable={false}
                minimumTouchDrag={80}
                showDots={false}
                responsive={mediaCarouselResponsive}
                ssr={false}
                infinite={false}
                partialVisible={true}
                keyBoardControl={true}
                transitionDuration={500}
                itemClass="px-0 border-start border-5 border-light"
            >
                {mediaPreview.map(({id, url, filename}, index) => (
                    <div key={String(id)} className="customer-photos-img-wrapper d-flex align-items-center flex-column"
                         onClick={() => setActiveIndex(index)}>
                        <Image src={url} alt={filename} className="img-fluid" style={{cursor:'pointer'}}/>
                    </div>
                ))}
            </Carousel>
            <Button variant="link" onClick={() => setActiveIndex(0)}>
                See all customer reviews with photos
            </Button>
            {activeMedium && (
                <Modal id="customer-photos-modal"
                       show={true}
                       onHide={() => setActiveIndex(undefined)}
                       size="xl"
                       centered>
                    <Modal.Header closeButton>
                        <h3> {header}  </h3>
                    </Modal.Header>
                    <Modal.Body>
                        <Container>
                            <Row className="align-items-center g-5">
                                <Col lg={6} className="carousel-column bg-dark">
                                    <BootstrapCarousel variant="light"
                                                       className="w-100"
                                                       activeIndex={activeIndex}
                                                       onSelect={(selectedIndex) => setActiveIndex(selectedIndex)}
                                                       interval={null}
                                                       wrap={true}
                                                       indicators={false}
                                                       prevIcon={<ModalPreviousIcon/>}
                                                       nextIcon={<ModalNextIcon/>}>
                                        {visibleMedia.map(({id, url, filename}) => (
                                            <BootstrapCarousel.Item key={id}>
                                                <div className="customer-images-carousel-wrap bg-dark">
                                                    <Image src={url} alt={filename}/>
                                                </div>
                                            </BootstrapCarousel.Item>
                                        ))}
                                    </BootstrapCarousel>
                                </Col>
                                <Col lg={6}>
                                    <div className="py-3 mt-1 user-rating-box" style={{height: '100%'}}>
                                        <StarRating grade={activeMedium.review.rating.grade}/>
                                        <small>({activeMedium.review.rating.gradeOutOfFive})</small>
                                        <small>
                                            <FaCheck className="ms-3 me-1 text-success"/>
                                            Verified Purchase
                                        </small>
                                        {activeMedium.review.rating.attributes.any && (
                                            <div className="ratings-variant-options text-muted d-flex flex-wrap mt-1">
                                                <small>
                                                    {activeMedium.review.rating.attributes.concatenate}
                                                </small>
                                            </div>
                                        )}
                                        {activeMedium.review.visible && (
                                            <h5 className="review-title my-2">
                                                {activeMedium.review.title}
                                            </h5>
                                        )}
                                        <small className="text-muted d-block mt-1">
                                            {activeMedium.review.rating.byline}
                                        </small>
                                        {activeMedium.review.visible && (
                                            <p className="mt-2">
                                                {activeMedium.review.text}
                                            </p>
                                        )}
                                    </div>
                                    {hasMedia && (
                                        <div>
                                            <strong className="d-block py-3">Images in this review</strong>
                                            <div className="d-flex flex-wrap thumbnails-wrap">
                                                {media.map(({id, url, filename, modalThumbnailStyle}, index) => (
                                                    <div key={String(id)}
                                                         className={`customer-image-wrap py-2${activeMedium.id === id ? " active border-primary" : ""}`}>
                                                        <Image src={url}
                                                               alt={filename}
                                                               style={modalThumbnailStyle(activeMedium.id)}
                                                               onClick={() => setActiveIndex(index)}/>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </Col>
                            </Row>
                        </Container>
                    </Modal.Body>
                </Modal>
            )}
        </Col>
    );
}

const ModalNextIcon = () => <FaChevronCircleRight
    aria-hidden="true"
    className="carousel-control-prev-icon text-primary bg-white rounded-circle"
    size={40}
    style={{filter: "none"}}
/>;

const ModalPreviousIcon = () => <FaChevronCircleLeft
    aria-hidden="true"
    className="carousel-control-prev-icon text-primary bg-white rounded-circle"
    size={40}
    style={{filter: "none"}}
/>;